import React from 'react';
import Img from '../Img';
import { TbFlag } from 'react-icons/tb';
import { PRODUCT_TAG_FLAG_CATEGORY_COUNTRY } from '../../../Utils/Constants/Product';

interface BadgeProductTagFlagProps {
    product: any;
    className?: string;
}

const BadgeProductTagFlag = ({
    product,
    className,
}: BadgeProductTagFlagProps) => {

    if (!product) return null;

    const tagFlag = product.tags.find((tag: any) => tag.tag_category_id === PRODUCT_TAG_FLAG_CATEGORY_COUNTRY && tag.icon);

    if (!tagFlag) return null;

    const defaultClass = 'aspect-square w-full max-w-5 min-w-5 rounded-full'

    return (
        <Img
            alt={tagFlag.name}
            title={tagFlag.name}
            className={`${className} ${defaultClass} shadow-md shadow-black/20 `}
            src={tagFlag.icon}
            fallback={
                <div className={`${className} ${defaultClass} flex items-center justify-center bg-gray-800/10 text-sm`}>
                    <TbFlag className='text-white' />
                </div>
            }
        />
    );

};

export default BadgeProductTagFlag;
